import React from 'react'
import style from './articles.style'

const AuthorizeErrors = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Почему UTM-метки необходимы для передачи рекламных расходов?</h2>
      <p>Для любого сайта, на который ведется реклама, важно знать эффективность каналов рекламного трафика.</p>
      <p>Универсальным методом разбивки рекламного трафика является использование utm-меток.</p>
      <p>Разметив utm-метками ссылки объявлений в рекламных кампаниях, в системе веб-аналитики можно понять количество переходов с конкретного канала (площадку, рекламную кампанию, конкретное объявление и т.д.). </p>
      <p>Далее, подключив ROMI center, данные по затратам и продажам отправляются в систему веб аналитики в разрезе utm-меток.
      ROMI center передает данные с НДС, то-есть вы увидите реальные данные по затратам, и неискаженные данные по ROMI.</p>
      <p>Utm-меток всего пять, обязательных из них только три.</p>
      <p>Utm_source — источник перехода (yandex, google).
Utm_medium — тип рекламного канала (cpc, cpm, email, affiliate).
Utm_campaign — рекламная кампания. 
Utm_content — дополнительная информация о рекламе (например, место размещения баннера или особенности объявления).
Utm_term — ключевая фраза или тема баннера.</p>
      <p>Обратите пожалуйста внимание, на особенность разметки кампаний в Google Ads для ROMI center.
Обязательное требование для разметки кампаний - нужно заменить utm-метку Utm_source=google_ads
Если в utm-метках объявлений Google Ads встретятся Utm_source=google, данные затратам для таких объявлений будут переданы с Utm_source=google_ads.</p>
      <p>ROMI center отправляет данные по затратам в привязке к трём utm-меткам: Utm_source, Utm_campaign, Utm_medium.</p>
      <p>Если в ваших рекламных кампаниях нет utm-меток, тогда ROMI center отправит данные по затратам со следующими значениями utm-меток:
<br/><br/><b>Яндекс.Директ: </b>
<br/>Utm_source=yandex
<br/>Utm_medium=cpc
<br/>Utm_campaign=yandex_direct
<br/><br/><b>Яндекс.Маркет:</b>
<br/>Utm_source=market.yandex.ru
<br/>Utm_medium=cpc
<br/>Utm_campaign=market
<br/><br/><b>Google Ads:</b>
<br/>Utm_source=google_ads
<br/>Utm_medium=cpc
<br/>Utm_campaign=google_ads
<br/><br/><b>Mytarget: </b>
<br/>Utm_source=mytarget
<br/>Utm_medium=cpc
<br/>Utm_campaign=default
<br/><br/><b>Vkontakte</b>
<br/>Utm_source=vk.com
<br/>Utm_medium=cpc
<br/>Utm_campaign=vk.com
<br/><br/><b>Facebook: </b>
<br/>Utm_source=facebook
<br/>Utm_medium=cpm
<br/>Utm_campaign=facebook 
<br/><br/><b>Instagram: </b>
<br/>Utm_source=instagram
<br/>Utm_medium=cpm
<br/>Utm_campaign=instagram 
<br/><br/><b>Criteo: </b>
<br/>Utm_source=criteo
<br/>Utm_medium=cpc
<br/>Utm_campaign=criteo</p>
    </article>
  )
}

export default style(AuthorizeErrors)
